import { MyMonitoringAccountCreatePage } from '@apps-common/apps/portal/pages/my-monitoring/pages/create/Index'

export const MyMonitoringAccountCreate = () => <MyMonitoringAccountCreatePage />
